import { useAverageSessionDuration } from '@va/dashboard/api-client/visitor-stats';
import { useSessionMetricsFilters } from '@va/dashboard/shared/filters';
import { useTranslate } from '@va/localization';
import { FiltersContextProvider } from '@va/shared/feature-filters';
import { TimePeriod } from '@va/types/time';
import { DateComparisonPeriod } from '@va/ui/components/report-block';
import { formatMomentDuration, formatTime } from '@va/util/helpers';
import moment from 'moment';
import { useCallback } from 'react';
import { useCurrentVisitorStatsParams, usePreviousVisitorStatsParams } from '../expandable-rb/useVisitorStatsParams';
import { VisitorStatsReport } from '../expandable-rb/VisitorStatsReport';
import { AVERAGE_SESSION_DURATION_FILE_NAME } from './constants';

const useCurrent = (unit: TimePeriod = TimePeriod.day) => {
  const params = useCurrentVisitorStatsParams();
  return useAverageSessionDuration({ ...params, unit });
};
const usePrevious = (activeComparisonOption: DateComparisonPeriod, unit: TimePeriod = TimePeriod.day) => {
  const params = usePreviousVisitorStatsParams(activeComparisonOption);
  return useAverageSessionDuration({ ...params, unit });
};

const AverageSessionsDurationCard = ({
  id,
  gridPosition,
  canExpand,
}: {
  id: string;
  gridPosition: number;
  canExpand?: boolean;
}) => {
  const valueMapper = useCallback(
    (val: number | string) => formatTime(formatMomentDuration(moment.duration(val, 'seconds'))),
    [],
  );

  const translate = useTranslate();
  const { allFilters } = useSessionMetricsFilters();

  return (
    <FiltersContextProvider allFilterOptions={allFilters} reportBlockId={id}>
      <VisitorStatsReport
        id={id}
        gridPosition={gridPosition}
        canExpand={canExpand}
        fetchCurrentHook={useCurrent}
        fetchPreviousHook={usePrevious}
        valueMapper={valueMapper}
        title={translate('latestVisitorsOverview.chart.averageSessionDuration.title')}
        titleTooltip={translate('latestVisitorsOverview.axisTimeFrame.averageSessionDuration.tooltip')}
        yAxisTickCallback={valueMapper}
        showTimePeriodFilter
        exportFileName={AVERAGE_SESSION_DURATION_FILE_NAME}
      />
    </FiltersContextProvider>
  );
};

export default AverageSessionsDurationCard;
